import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeAllSaversCarriers } from './normalize';

export const fetchAllSaversCarriers = createProvider(api.fetchAllSaversCarriers)
  .andThen((res) => normalizeAllSaversCarriers(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
